module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/sms-mail-alert-36ba7f2d4935cb83b83d6cf1735438fa.svg";